var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.3125V2H4.9375C4.41797 2 4 2.41797 4 2.9375V21.0625C4 21.582 4.41797 22 4.9375 22H18.0625C18.582 22 19 21.582 19 21.0625V8.25H13.6875C13.1719 8.25 12.75 7.82812 12.75 7.3125ZM15.7363 15.5687L11.9699 19.307C11.7102 19.5652 11.2906 19.5652 11.0309 19.307L7.26445 15.5687C6.86797 15.1754 7.14609 14.5 7.70391 14.5H10.25V11.375C10.25 11.0297 10.5297 10.75 10.875 10.75H12.125C12.4703 10.75 12.75 11.0297 12.75 11.375V14.5H15.2961C15.8539 14.5 16.132 15.1754 15.7363 15.5687ZM18.7266 6.10156L14.9023 2.27344C14.7266 2.09766 14.4883 2 14.2383 2H14V7H19V6.76172C19 6.51562 18.9023 6.27734 18.7266 6.10156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDoc);
export default __webpack_public_path__ + "static/media/download-doc.499eb1f41c777d95520ef6095ec58e4c.svg";
export { ForwardRef as ReactComponent };